import * as React from "react";
import { InformationIcon } from "./InformationIcon";
import classNames from "classnames";
import { Button, Card, Classes, Dialog, Intent } from "../../index";

export type ConfirmModalProps = {
    message: React.ReactNode;
    intent?: Intent;
    onClose: () => void;
};

export const InformationModal: React.FC<ConfirmModalProps> = ({ message, intent, onClose }) => {
    return (
        <Dialog onClose={onClose} isOpen isCloseButtonShown={false}>
            <div className={Classes.DIALOG_BODY}>
                <Card className={"bg-background-2 d-flex flex-column align-items-center"}>
                    <div>
                        <InformationIcon />
                    </div>
                    <div className={"modal-bigger-text mt-3"}>{message}</div>
                </Card>
            </div>
            <div className={classNames(Classes.DIALOG_FOOTER, "d-flex justify-content-center")}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button onClick={onClose} intent={intent} className={"half-width ml-0"}>
                        {"Rozumím"}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
